import { render, staticRenderFns } from "./BPDefinition.vue?vue&type=template&id=8c51c592&"
import script from "./BPDefinition.vue?vue&type=script&lang=js&"
export * from "./BPDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports